<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication-break" id="dedication"><a id="pv"></a><i>A Brief Note</i></p>
<p class="dedi-center">This book is dedicated to no one in particular.</p>
<p class="dedi-center">There is no “Tom, Dick, or Harry” in my lexicon.</p>
<p class="dedi-center">I have written this book for those who enjoyed seeing me on the screen and on the stage, for those who made it possible for me to work, to earn money, to pay my taxes and to enjoy life’s fleeting pleasures.</p>
<p class="dedi-center">Perhaps they will read this book.</p>
<p class="dedi-center">Perhaps they will laugh a little with me.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?15f03447